import { NextApiRequestCookies } from 'next/dist/server/api-utils';
import { GTAGPrefix } from 'src/hooks/useGTAG';
import { ItemListName } from './analytic.types';

export enum FilterTypes {
  Values = 'VALUES',
  Range = 'RANGE',
  ValuesSearch = 'VALUES_SEARCH'
}

export enum DrugQuantityType {
  Pack = 'PACK',
  Unit = 'UNIT'
}

export type RequestParams = {
  url?: string;
  // TODO: replace any type with the actual type!
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any;
  attr?: FetchAttr;
};
export class APIError {
  code: string | number;

  statusMessage: string;

  message: string;

  data: {
    [key: string]: string | string[];
  };

  requestParams: string;

  constructor(
    code: string | number,
    statusMessage: string,
    data?: {
      [key: string]: string | string[];
    },
    requestParams?: RequestParams
  ) {
    this.code = code;
    this.statusMessage = statusMessage;
    this.message = (data?.errors && data.errors[0]) || null;
    this.data = data;
    this.requestParams = JSON.stringify(requestParams);
  }
}
export interface APIHookResponse {
  isLoading: boolean;
  error?: APIError;
}

export enum DrugPlateFieldStatus {
  Red = 'RED',
  Green = 'GREEN',
  Orange = 'ORANGE'
}

export type DrugPlateField = {
  text: string;
  color: DrugPlateFieldStatus;
};

export type Article = {
  translitName: string;
  seoTitle: string;
  seoDescription: string;
  title: string;
  content: string;
  doctorReviewer?: DoctorReviewer;
};

export type ArticlePreview = {
  translitName: string;
  title: string;
  content: string;
};

export type DrugItem = {
  restCode: string;
  price: number;
  unitName: string;
  unitQuantity: number;
  packQuantity: number;
  quantityUnitInPack: number;
  id: string;
  imageExists: boolean;
  externalId: string;
  image: string;
  categoryId: string;
  category: string;
  categories?: {
    firstLevel: { translitName: string; name: string };
    secondLevel: { translitName: string; name: string };
    thirdLevel: { translitName: string; name: string };
  };
  doze: string;
  packaging: string;
  form: string;
  instructionForm: string;
  pharmacodinamica: string;
  pharmacokinetiks: string;
  pharmGroup: string;
  morionCode: string;
  atx: string;
  tradeName: string;
  tradeNameLink: {
    translitName: string;
    name: string;
  };
  reactionSpeed: string;
  pregnancy: string;
  children: string;
  name: string;
  lastUpdateDate: string;
  maker: string;
  component: string;
  quantityInPack: number;
  inputType: string;
  composition: string;
  makerCountry: string;
  description: string;
  indications: string;
  application: string;
  contraindications: string;
  sideEffects: string;
  interactions: string;
  overdose: string;
  storageConditions: string;
  expiration: string;
  forAllergic: DrugPlateField;
  forDiabetic: DrugPlateField;
  forDrivers: DrugPlateField;
  forMothers: DrugPlateField;
  forPregnant: DrugPlateField;
  forChildren: DrugPlateField;
  storageTemperature: DrugPlateField;
  withAlcohol: DrugPlateField;
  withRecipe: DrugPlateField;
  status: string;
  discount?: number;
  foundInBranchesCount?: number;
  maxPrice?: number;
  minPrice?: number;
  rating?: number;
  translitName: string;
  relatedDozes: { translitName: string; drugId: string; label: string }[];
  relatedPackage: { translitName: string; drugId: string; label: string }[];
  seo?: {
    robots: string;
  };
  withAnalogs?: boolean;
  averageRate?: number;
  rateCount?: number;
  analytics?: {
    itemListName: ItemListName;
    index: string;
  };
};

export type TradenameItemLetter = {
  translitName: string;
  name: string;
};

export type TradenameItem = {
  minPrice: number;
  maxPrice: number;
  translitName: string;
  name: string;
  letter: TradenameItemLetter;
  description: string;
  tradeNameInCity: boolean;
  doctorReviewer?: DoctorReviewer;
  averageRate?: number;
  rateCount?: number;
};

export type ClientInfo = {
  id: string;
  phone: string;
  name: string;
  surname: string;
  email: string;
  lastUpdateDate: string;
  birthDate: string;
  gender: string;
  height: number;
  weight: number;
  bloodType: string;
  allergic: boolean;
  hypertension: boolean;
  diabetes: boolean;
  asthma: boolean;
  sport: boolean;
  healthy: boolean;
};

export type FilterValue = {
  count: number;
  name: string;
  id: string;
  // TODO: replace any type with the actual type!
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: any[];
};

export type Filter = {
  type?: string;
  name?: string;
  id: string;
  values?: FilterValue[];
  selectedValues?: (string | number)[];
  valueIds?: string[];
  min?: number;
  max?: number;
};

export type SelectedFilter = {
  id: string;
  selectedValues?: (string | number)[];
};

export type BranchItem = {
  branchCode: 'string';
  price: number;
  distance: number;
};

export enum PackType {
  PACK = 'PACK'
  // Currently unsupported
  // ITEM = 'ITEM'
}

export type CartItem = {
  quantityUnitInPack: number;
  packQuantity: number;
  unitQuantity: number;
  drug: DrugItem;
  packType: PackType;
};

export type LocalStorageCartItem = {
  packQuantity: number;
  unitQuantity: number;
  quantityUnitInPack: number;
  translitName: string;
  packType: PackType;
  // This two props are only for gtag
  gtagPrefix?: GTAGPrefix;
  name?: string;
  analytics?: DrugItem['analytics'];
};

export type ProposalItem = {
  branchCode: string;
  partnerId: string;
  rests: {
    quantity: number;
    unitName: string;
    quantityUnitInPack: number;
    drug: DrugItem;
    packType: PackType;
    packQuantity: number;
    unitQuantity: number;
    price: number;
    priceReserve: number;
    priceWithoutDiscount: number | null;
    discount: number;
    restCode: string;
  }[];
  branchName: string;
  branchWorkTime: string;
  branchLatitude: string;
  branchLongitude: string;
  branchPhones: string[];
  branchAddress: string;
  partnerName: string;
  distance: number;
  discountProgram?: { text: string; link: string } | null;
  favouriteBranch: boolean;
  price?: number;
  priceWithoutDiscount?: number | null;
  branchLabel?: {
    text: string;
    color: 'GREEN' | 'ORANGE' | 'BLUE';
  };
};

export type DoctorReviewer = {
  id: string;
  name: string;
  speciality: string;
  experience: string;
  reviewDate: string;
};

export type SubCategory = {
  id: string;
  name: string;
  description?: string;
  translitName: string;
  doctorReviewer?: DoctorReviewer;
};

export type Category = {
  id: string;
  name: string;
  translitName: string;
  subCategories: SubCategory[];
};

export type ThirdCategoryLevel = {
  name?: string;
  translitName: string;
  description?: string;
  doctorReviewer?: DoctorReviewer;
};

export type SecondCategoryLevel = {
  name?: string;
  translitName: string;
  description?: string;
  doctorReviewer?: DoctorReviewer;
  subCategories?: ThirdCategoryLevel[];
};

export type FirstCategoryLevel = {
  id?: string;
  name?: string;
  translitName: string;
  description?: string;
  doctorReviewer?: DoctorReviewer;
  subCategories?: SecondCategoryLevel[];
};

export type Analogue = {
  drugId: string;
  drugTranslitName: string;
  drugName: string;
  minPrice: number;
  maxPrice: number;
};

export type TopDrug = {
  id: string;
  name: string;
  translitName: string;
  quantityUnitInPack: number;
  foundInBranchesCount: number;
  minPrice: number;
  maxPrice: number;
  unitName: string;
};

export type AllAnalogues = {
  fullAnalogue: AccordionItemContentType[];
  otherFormAnalogue: AccordionItemContentType[];
  sameEffectFormAnalogue: AccordionItemContentType[];
};

export type OtherTradeName = {
  translitName: string;
  name: string;
};

export type AccordionHeaderContent = {
  id: string;
  title: string;
  description?: string | JSX.Element;
  useCustomWrapper?: (titleChild: string) => string | JSX.Element;
};

// TODO: replace any type with the actual type!
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AccordionItemContentType = any;

export type FastSearchCategory = {
  translitName: string;
  name: string;
};

export type FastSearchTradeNames = {
  name: string;
  translitName: string;
};

export type UserLocation = {
  name: string;
  translitName?: string;
  latitude: string;
  longitude: string;
  districtName: string;
  distance?: number | null;
  nearest?: boolean;
  // This prop is required to initiate all hooks depending on the location
  forceUpdate?: boolean;
};

export type StoreLocation = {
  latitude: string;
  longitude: string;
};

export type FetchAttr = {
  cookies?: NextApiRequestCookies;
  locationOverride?: UserLocation;
  shareLatitudeLongitude?: boolean;
  ip?: string;
  locale?: string;
  authRequired?: boolean;
  useCache?: boolean;
  recaptchaToken?: string | null;
};

export enum MemberBloodType {
  A_PLUS = 'A_PLUS',
  A_MINUS = 'A_MINUS',
  B_PLUS = 'B_PLUS',
  B_MINUS = 'B_MINUS',
  O_PLUS = 'O_PLUS',
  O_MINUS = 'O_MINUS',
  AB_PLUS = 'AB_PLUS',
  AB_MINUS = 'AB_MINUS'
}

export enum MemberGender {
  FEMALE = 'FEMALE',
  MALE = 'MALE'
}

export enum BookingType {
  COMMON = 'COMMON',
  FAST = 'FAST'
}

export type UserAuthorization = {
  id: string;
  token: string;
  role: string;
  phone: string;
};

export enum MemberOrderStatus {
  NEW = 'NEW',
  RECEIVED = 'RECEIVED',
  APPROVED = 'APPROVED',
  PAID = 'PAID',
  CANCELED = 'CANCELED',
  CANCELED_BY_LIKIE = 'CANCELED_BY_LIKIE',
  CANCEL_APPROVED = 'CANCEL_APPROVED',
  DELIVERED = 'DELIVERED'
}

export type MemberOrder = {
  id: string;
  code: string;
  canBeProlongated: boolean;
  partnerOrderCode: string;
  partnerId: string;
  branchCode: string;
  brandName: string;
  branchLatitude: string;
  branchLongitude: string;
  status: MemberOrderStatus;
  userPhone: string;
  okpo: string;
  notes: [
    {
      text: string;
      author: string;
      updateTime: Date;
      orderStatus: MemberOrderStatus;
    }
  ];
  items: [
    {
      quantity: number;
      unitName: string;
      quantityUnitInPack: number;
      drugId: string;
      translitName: string;
      packQuantity: number;
      unitQuantity: number;
      price: number;
      discount: number;
      name: string;
      packType: PackType;
      imageExists: boolean;
    }
  ];
  createDate: Date;
  paidDate: Date;
  itemsCount: number;
  price: number;
  branchAddress: string;
  branchWorkingTime: string;
  deliveryType: string;
  paymentType: string;
  terms: string;
  progressBarPercent: number;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortBy {
  popularity = 'popularity',
  name = 'name',
  relevance = 'relevance',
  price = 'price'
}

export enum BlogSortBy {
  createDate = 'createDate',
  views = 'views'
}

export enum ProposalsSortBy {
  price = 'PRICE',
  distance = 'DISTANCE'
}

export type BookingOrder = {
  showRateVoting: boolean;
  userPhone: string;
  id: string;
  branchCode: string;
  branchBrand: string;
  price: number;
  code;
  items: {
    drug: {
      id: string;
      name: string;
      categoryId: string;
      maker: string;
      category: string;
      quantityUnitInPack: number;
    };
    drugCategoryId: string;
    discount: number;
    price: number;
    packQuantity: number;
    unitQuantity: number;
    restCode: string;
    restName: string;
    quantity: number;
  }[];
  promoCode?: string | null;
};

export type User = {
  id: string;
  phone: string;
  name: string;
  surname: string;
  email: string;
  lastUpdateDate: string;
  birthDate: string;
  gender: string;
  height: number;
  weight: number;
  bloodType: string;
  allergic: boolean;
  hypertension: boolean;
  diabetes: boolean;
  asthma: boolean;
  sport: boolean;
  healthy: boolean;
};

export type FavouriteBranch = {
  brand: string;
  code: string;
  partnerId: string;
  address: string;
  workingTime: string;
  destinationLink: string;
};

export type RestQuantity = {
  rests: {
    restCode: string;
    maxQuantity: number;
    maxPackQuantity: number;
    maxUnitQuantity: number;
    quantityUnitInPack: number;
  }[];
};

export type Rest = {
  unitName: string;
  packQuantity: number;
  unitQuantity: number;
  quantity: number;
  quantityUnitInPack: number;
  drug: DrugItem;
  packType: PackType;
  price: number;
  priceReserve: number;
  priceWithoutDiscount: number | null;
  discount: number;
  restCode: string;
  partnerId?: string;
  branchCode?: string;
  restCodes?: string[];
};

export type BlogItem = {
  translitName: string;
  title: string;
  content: string;
  views: number;
  createDate: string;
};

export type PriceHistory = {
  date: string;
  value: number;
};

export type DrugReview = {
  userName: string;
  rating: number;
  createDate: Date;
  comment: string;
  drugTranslitName?: string;
  drugName?: string;
};
